<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>预测信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="区域" class="h-elformWrap-2" required="">
                                                <el-select v-model="saveData.area" filterable class="h-tableInput">
                                                    <el-option v-for="(item,index) in areaList" :key="index" :label="item.qyname" :value="item.qycode" >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="国家名称" class="h-elformWrap-2" required="">
                                                <el-select v-model="saveData.country" filterable class="h-tableInput" @change="clickmodel">
                                                    <el-option v-for="(item,index) in gjCo" :key="index" :label="item" :value="item" >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2" required="">
                                                <el-select class="h-tableInput" filterable v-model="saveData.productCode"    @change="selectCode">
                                                    <el-option v-for="(item,index) in pCode" :key="index" :label="item" :value="item">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-select class="h-tableInput" filterable  v-model="saveData.productModel"disabled=""  >
                                                    <el-option v-for="(item,index) in pModel" :key="index" :label="item" :value="item">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" required="">
                                                <el-input class="h-tableInput" v-model="saveData.factory" disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="规格型号" class="h-elformWrap-2" required="">
                                                <el-input placeholder="请输入..." class="h-tableInput" v-model="saveData.oemDesc" disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="数量" class="h-elformWrap-2" required="">
                                                <el-input v-model="saveData.proNumber" placeholder="产品数量" class="h-tableInput"
                                                          oninput="value=value.toString().match(/^\d+(?:\.\d{0,2})?/)">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="发货方式" class="h-elformWrap-2" required="">
                                                <el-select class="h-tableInput" v-model="saveData.deliveryMethod">
                                                    <el-option value="1" label="直发"></el-option>
                                                    <el-option value="2" label="库发"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否实单" class="h-elformWrap-2" required="">
                                                <el-select class="h-tableInput" v-model="saveData.isReal">
                                                    <el-option value="1" label="实单"></el-option>
                                                    <el-option value="0" label="备货"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="预计交货时间" class="h-elformWrap-2" required="">
                                                <el-date-picker v-model="saveData.deliveryDate" type="date" :clearable="false"
                                                                class="h-tableInput"
                                                                value-format="yyyy-MM-dd" :placeholder="saveData.deliveryDate"
                                                                placeholder="请选择日期" :picker-options="pickerOptions">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2">
                                                <el-input v-model="saveData.remark" placeholder="备注" class="h-tableInput"></el-input>
                                            </el-form-item>
                                            <!-- 附件上传 -->
                                            <el-form-item v-if="this.lkFlag" prop="fileUrl" label="方案图纸" class="h-elformWrap-2" :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                                                <brupload
                                                        v-model="fileUrl"
                                                        :refid=lkYcid
                                                        reftype="WXYC_LKFJ"
                                                        :limit="1"
                                                        :showtime="false"
                                                        uploadflag
                                                        delflag
                                                        @filecallback=isUpload>
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item v-if="this.lkFlag" prop="fileUrl" label="施工确认单" class="h-elformWrap-2" :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                                                <brupload
                                                        v-model="fileUrl"
                                                        :refid=lkYcid
                                                        reftype="WXYC_SGQRD"
                                                        :limit="1"
                                                        :showtime="false"
                                                        uploadflag
                                                        delflag
                                                        @filecallback=isUpload>
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="海尔标准配置" class="h-elformWrap-2" v-if="this.lkFlag" required="" >
                                                <el-select class="h-tableInput" v-model="saveData.isStandard" @change="isStandardChange" placeholder="请选择">
                                                    <el-option value="1" label="是"></el-option>
                                                    <el-option value="2" label="否"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-if="isAddress" label="收货地址" class="h-elformWrap-2" prop="receivingAddress" required="">
                                                <el-input readonly v-model="saveData.receivingAddress"
                                                          :title="saveData.receivingAddress"
                                                          placeholder="收货地址...">
                                                    <i
                                                            class="el-icon-search el-input__icon"
                                                            slot="suffix"
                                                            v-if="isAddress"
                                                            @click="handleIconClick">
                                                    </i>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item v-if="this.lkFlag " prop="fileUrl" label="投标参数" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                                                <brupload
                                                        v-model="fileUrl"
                                                        :refid=lkYcid
                                                        reftype="WXYC_TBCS"
                                                        :limit="1"
                                                        :showtime="false"
                                                        uploadflag
                                                        delflag
                                                        @filecallback=isUpload>
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="选择预排单号" class="h-elformWrap-2" v-if="isNotDisplay && saveData.protype=='自产' && (saveData.isOther == '' || saveData.isOther == null)">
                                                <el-select v-model="saveData.ypIds" clearable placeholder="请选择" allow-create filterable
                                                           class="h-tableInput" :multiple="true" @change="getYbTable">
                                                    <el-option v-for="(item, index) in getypData" :key="index" :label="item.id"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="常规或改制" class="h-elformWrap-2" required="">
                                                <brselect category="shifou_dingzhi" :v="saveData.isSpecific"
                                                          v-model="saveData.isSpecific" placeholder="请选择"
                                                          @change="changes()" class="h-tableInput"/>
                                            </el-form-item>
                                            <el-form-item label="总单台加价(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                                                <el-input placeholder="请输入..." v-model="saveData.reformPriceRmb" disabled=""></el-input>
                                            </el-form-item>
                                            <el-form-item label="占用预测单类型" class="h-elformWrap-2" v-if="saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)" >
                                                <el-select class="h-tableInput" v-model="saveData.isOther" @change="isYp" placeholder="请选择">
                                                    <el-option value="" label=""></el-option>
                                                    <el-option value="1" label="自己"></el-option>
                                                    <el-option value="2" label="他人"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="使用已预测单号" class="h-elformWrap-2" v-if="saveData.isOther=='1' && saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)">
                                                <el-select v-model="saveData.useData" clearable placeholder="请选择" allow-create filterable
                                                           class="h-tableInput" @change="addUseId()" :multiple="true" :disabled="disabled">
                                                    <el-option v-for="(item, index) in saveData.uids" :key="index" :label="item.code"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="使用他人已预测单号" class="h-elformWrap-2"  v-if="saveData.isOther=='2' && saveData.isSpecific=='2' && (saveData.isScheduling == '' || saveData.isScheduling == null)">
                                                <el-select v-model="saveData.useOtherData" clearable placeholder="请选择" allow-create filterable
                                                           class="h-tableInput" @change="addUseIdOther()" :multiple="true" :disabled="disabled">
                                                    <el-option v-for="(item, index) in saveData.otherUseIds" :key="index" :label="item.code"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="占用改制加价(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                                                <el-input placeholder="请输入..." v-model="saveData.otherYcReformPrice" disabled=""></el-input>
                                            </el-form-item>

                                            <el-form-item label="改制类型" class="h-elformWrap-2" required=""  v-if="saveData.isSpecific=='2' ">
                                                <el-select class="h-tableInput" v-model="saveData.isReformStock" :disabled="this.isKcgz">
                                                    <el-option value="0" label="生产改制"></el-option>
                                                    <el-option value="1" label="库存改制"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <div style="margin-top: 30px;" v-if="saveData.isSpecific == '2'">
                                                <i @click="addSpecific()" style="float:right;font-size:20px;margin-right: 30%" class="el-icon-circle-plus"></i>

<!--                                                <el-button @click="createSpecific()"  size="mini" class="h-btn h-bBtn h-bgblueQ2"
                                                           style="float:right;margin-right: -20%">新增改制条目</el-button>-->

                                                <div v-for="(listIt, index) in saveData.specificList" :key="index" class="h-formBox">

                                                    <i @click="deleteSpecific(index)" v-show="index != 0" style="float:right;font-size:20px;margin-right: 30%;color:crimson;"
                                                       class="el-icon-remove"></i>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制目录{{index+1}}
                                                        </template>
                                                        <el-select value-key="id" filterable  v-model="saveData.specificList[index].specificDivision" placeholder="请选择"  @change="chooseDivision($event,index)">
                                                            <el-option v-for="item in specificDivisionList" :key="item"
                                                                       :label="item.specificDivision" :value="item">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制要求{{index+1}}
                                                        </template>
                                                        <el-select value-key="id" v-if="saveData.specificList[index].specificType==1" filterable  v-model="saveData.specificList[index].specificReform" placeholder="请选择"  @change="chooseReform($event,index)" >
                                                            <el-option v-for="item in specificReformList[index]" :key="item.id"
                                                                       :label="item.specificReform" :value="item">
                                                            </el-option>
                                                        </el-select>
                                                        <el-input v-if="saveData.specificList[index].specificType==2" placeholder="请输入改制要求" v-model="saveData.specificList[index].specificReform" ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制备注{{index+1}}
                                                        </template>
                                                        <el-input  type="textarea" autosize placeholder="请输入改制备注" v-model="saveData.specificList[index].specificRemark"></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台改制数量{{index+1}}
                                                        </template>
                                                        <el-input placeholder="请输入改制数量" v-model="saveData.specificList[index].reformNum" @change="calReformPrice"></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="由财务填写" v-model="saveData.specificList[index].reformPrice" readonly></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                    <div v-if="ycTable.length > 0" style="width: 95%">
                        <label style="font-size: 14px;margin-left: 20px;">占用预测库存信息</label>
                        <el-table
                                ref="multipleTable"
                                :data="ycTable"
                                stripe
                                border
                                max-height="500"
                                style="width: 100%;margin-left: 2%">
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="id"
                                    width="160"
                                    :show-overflow-tooltip="true"
                                    label="预测编码">
                            </el-table-column>
                            <el-table-column
                                    prop="country"
                                    width="90"
                                    :show-overflow-tooltip="true"
                                    label="国家名称">
                                <template slot-scope="scope">
                                    <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proModel"
                                    width="140"
                                    :show-overflow-tooltip="true"
                                    label="型号">
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    width="120"
                                    :show-overflow-tooltip="true"
                                    label="产品编码">
                            </el-table-column>
                            <el-table-column
                                    prop="protype"
                                    width="90"
                                    label="型号属性"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="proNumber"
                                    width="60"
                                    :show-overflow-tooltip="true"
                                    label="数量">
                            </el-table-column>
                            <el-table-column
                                    prop="useNumber"
                                    :show-overflow-tooltip="true"
                                    width="100"
                                    label="可录单数量">
                            </el-table-column>
                            <el-table-column
                                    prop="useInventory"
                                    width="120"
                                    :show-overflow-tooltip="true"
                                    label="使用库存数量">
                            </el-table-column>
                            <el-table-column
                                    prop="stockStatus"
                                    width="90"
                                    label="库存状态">
                                <template slot-scope="scope">
                                    <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="isSpecific"
                                    width="110"
                                    :show-overflow-tooltip="true"
                                    label="常规或改制">
                                <template slot-scope="scope">
                                    <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="reformPriceRmb"
                                    :show-overflow-tooltip="true"
                                    min-width="90"
                                    label="总单台加价(元)">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="specificReform"
                                    :show-overflow-tooltip="true"
                                    min-width="180"
                                    label="改制要求">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.specificReform}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    :show-overflow-tooltip="true"
                                    min-width="180"
                                    label="备注">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">
                                        {{scope.row.remark}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="cuname"
                                    width="90"
                                    label="创建人">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="OtherTable.length > 0" style="width: 95%">
                        <!--                            <label style="font-size: 34px" v-if="OtherTable.length > 0">被占用预测单详情</label>-->
                        <label style="font-size: 14px;margin-left: 20px;">占用他人预测库存信息</label>
                        <el-table
                                ref="multipleTable"
                                :data="OtherTable"
                                stripe
                                border
                                max-height="500"
                                style="width: 100%;margin-left: 2%">
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="id"
                                    width="160"
                                    :show-overflow-tooltip="true"
                                    label="预测编码">
                            </el-table-column>
                            <el-table-column
                                    prop="country"
                                    width="90"
                                    :show-overflow-tooltip="true"
                                    label="国家名称">
                                <template slot-scope="scope">
                                    <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proModel"
                                    width="140"
                                    :show-overflow-tooltip="true"
                                    label="型号">
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    width="120"
                                    :show-overflow-tooltip="true"
                                    label="产品编码">
                            </el-table-column>
                            <el-table-column
                                    prop="protype"
                                    width="90"
                                    label="型号属性"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="proNumber"
                                    width="60"
                                    :show-overflow-tooltip="true"
                                    label="数量">
                            </el-table-column>
                            <el-table-column
                                    prop="useNumber"
                                    :show-overflow-tooltip="true"
                                    width="100"
                                    label="可录单数量">
                            </el-table-column>
                            <el-table-column
                                    prop="useInventory"
                                    width="120"
                                    :show-overflow-tooltip="true"
                                    label="使用库存数量">
                            </el-table-column>
                            <el-table-column
                                    prop="isSpecific"
                                    width="110"
                                    :show-overflow-tooltip="true"
                                    label="常规或改制">
                                <template slot-scope="scope">
                                    <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="reformPriceRmb"
                                    :show-overflow-tooltip="true"
                                    min-width="90"
                                    label="总单台加价(元)">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="specificReform"
                                    :show-overflow-tooltip="true"
                                    min-width="180"
                                    label="改制要求">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">{{scope.row.specificReform}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    :show-overflow-tooltip="true"
                                    min-width="180"
                                    label="备注">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">
                                        {{scope.row.remark}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="stockStatus"
                                    width="90"
                                    label="库存状态">
                                <template slot-scope="scope">
                                    <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="cuname"
                                    width="90"
                                    label="创建人">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="ybTable.length > 0" style="width: 95%">
                        <label style="font-size: 14px;margin-left: 20px;">占用预排信息</label>
                        <el-table
                                ref="multipleTable"
                                :data="ybTable"
                                stripep
                                border
                                max-height="500"
                                style="width: 100%;margin-left: 2%">
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="id"
                                    width="160"
                                    :show-overflow-tooltip="true"
                                    label="预测编码">
                            </el-table-column>
                            <el-table-column
                                    prop="country"
                                    width="90"
                                    :show-overflow-tooltip="true"
                                    label="国家名称">
                                <template slot-scope="scope">
                                    <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="proModel"
                                    width="140"
                                    :show-overflow-tooltip="true"
                                    label="型号">
                            </el-table-column>
                            <el-table-column
                                    prop="proCode"
                                    width="160"
                                    :show-overflow-tooltip="true"
                                    label="产品编码">
                            </el-table-column>
                            <el-table-column
                                    prop="protype"
                                    width="90"
                                    label="型号属性"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="proNumber"
                                    width="60"
                                    :show-overflow-tooltip="true"
                                    label="数量">
                            </el-table-column>
                            <el-table-column
                                    prop="useNumber"
                                    :show-overflow-tooltip="true"
                                    width="100"
                                    label="剩余数量">
                            </el-table-column>
                            <el-table-column
                                    prop="remark"
                                    :show-overflow-tooltip="true"
                                    min-width="180"
                                    label="备注">
                                <template slot-scope="scope">
                                    <div style="text-align: left;">
                                        {{scope.row.remark}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="cuname"
                                    label="创建人">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                        <el-button class="h-btn h-bBtn h-bggreen" @click="submitFlage('暂存')">暂存</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitFlage('提交')">确认提交</el-button>
                    </div>
                    <!--收货地址-->
                    <areaSelect :visible.sync="showflag" @choseObj="choseAddress" v-if="showflag"
                                v-model="saveData.receivingAddress" :append-to-body = "true"/>
                </div>
            </div>

            <el-dialog :close-on-click-modal="false"  :visible.sync="createSpecificFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>新增改制条目</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <el-form ref="specificForm" :model="createSpecificData" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item  label="大类编码" class="h-elformWrap-2" label-width="100" prop="oneLId" :rules="[{ required: true, message: '请选择产品大类', trigger: 'blur'},]">
                            <el-select value-key="id" filterable  v-model="createSpecificData.oneLId" placeholder="请选择" @change="getOneLName">
                                <el-option v-for="item in allOne" :key="item.oneLId"  :label="`[${item.oneLId}] ${item.oneLName}`" :value="item.oneLId"  >
                                </el-option>
                            </el-select>

                        </el-form-item>
                        <el-form-item  label="大类名称" class="h-elformWrap-2" label-width="100" prop="oneLName" >
                            <el-input placeholder="输入大类编码自动带出" v-model="createSpecificData.oneLName" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="链群" class="h-elformWrap-2" prop="lianqunCode" :rules="[{ required: true, message: '请选择链群', trigger: 'blur'},]">
                            <el-select v-model="createSpecificData.lianqunCode" placeholder="请选择" @change="getLianqunName">
                                <el-option v-for="item in allLianqun" :key="item.lianqunCode" :label="item.lianqunName" :value="item.lianqunCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="改制目录" class="h-elformWrap-2" prop="specificDivision" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                            <el-select value-key="id"  filterable  v-model="createSpecificData.specificDivision" placeholder="请选择" clearable>
                                <el-option v-for="item in allDivision" :key="item"  :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="改制类型" prop="prodtype" class="h-elformWrap-2">
                            <el-select v-model="createSpecificData.specificType" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="内销" value="1"></el-option>
                                <el-option label="外销" value="2"></el-option>
                                <el-option label="通用" value="3"></el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="改制要求" class="h-elformWrap-1" prop="specificReform" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                            <el-input placeholder="请输入" v-model="createSpecificData.specificReform" style="width: 84%;"></el-input>
                        </el-form-item>
                        <el-form-item label="单台加价" class="h-elformWrap-2" prop="reformPrice" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                            <el-input placeholder="请输入" v-model.number="createSpecificData.reformPrice" ></el-input>
                        </el-form-item>

                        <el-form-item label="备注" class="h-elformWrap-1"  prop="remark">
                            <el-input v-model="createSpecificData.remark" style="width: 84%;"></el-input>
                        </el-form-item>
                    </el-form>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="closeSpecific">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitSpecific()">提交</el-button>
                    </div>
                </div>
            </el-dialog>

        </div>
    </div>
</template>
<script>
    import ss from '../../../../api/SystemService';
    import specificCatalogue from "../../../../api/reform/specificCatalogue.js";
    import _ from "loadsh";
    export default {
        data() {
            return {
                orderNumber:'',
                submitData:[],
                describe: [
                    {
                        specificId: '1',
                        des: '更改电源线'
                    },
                    {
                        specificId: '2',
                        des: '更改铭牌'
                    },
                    {
                        specificId: '3',
                        des: '外箱加贴唛头等'
                    },
                    {
                        specificId: '4',
                        des: '更改说明书/售后手册/检测报告等'
                    },
                    {
                        specificId: '5',
                        des: '内销型号改外销'
                    },
                    {
                        specificId: '6',
                        des: '拆电池'
                    },
                    {
                        specificId: '7',
                        des: '冰排放水'
                    },
                    {
                        specificId: '8',
                        des: '更改外包装箱'
                    },
                    {
                        specificId: '9',
                        des: '增加USB'
                    },
                    {
                        specificId: '11',
                        des: '增加圆盘记录仪'
                    },
                    {
                        specificId: '0',
                        des: '目录外改制'
                        },
                        {
                            specificId: '12',
                            des: '电动门功能'
                        }
                    ],
                areaList:[],
                userRole: [],
                instid: '',
                showhistory: false,
                ycTable:[],
                ycList:[],
                isYPdisabled:false,
                getypData:[],
                ybTable:[],
                disabledOther:false,
                getOtherData:[],
                OtherTable:[],
                ypDisabled:true,
                saveData:{
                    productModel:'',
                    area:null,
                    isReal:'',
                    ypIds:[],
                    isOther:'',
                    otherNumber:0,
                    ypNumber:0,
                    oneNumber:0,
                    otherUseIds:[],
                    useOtherData:[],
                    deliveryMethod:'',
                    isReformStock:null,
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:0,
                    proModel:'',
                    proCode:'',
                    country:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    otherYcReformPrice:0,
                    specific:'',
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:'',
                    useId:'',
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                    fileUrl:[],
                    isLk: 0,
                    lkYcId: '',
                    isStandard: '',
                    receivingAddress: '',
                    oemDesc: '',
                    factory:'',
                    specificList: [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:1,//改制数量
                        specificRemark:'',//改制备注
                    }],
                    proModelCode:'',
                },
                subLkData: {
                    id: '',
                    isStandard: '',
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                gjCo:[],
                f: {
                    productModel: '',
                    productCode: ''
                },
                pModel: [],
                pCode: [],
                pCodecopy: [],
                items: {},
                disabled:true,
                showflag: false,
                isNotDisplay:null,
                isKcgz:false,
                lkFlag:false,
                lkYcid: '',
                lkfjFlag:false,
                isOemAnd6200:false,
                isAddress:false,
                fileUrl:[],
                specificCatalogueList:[],
                specificDivisionList:[],
                lianqunList:[],
                rules:{
                    fileUrl: [
                        { required: true, message: '请上传冷库附件', trigger: 'blur' }
                    ]
                },
                createSpecificFlag:false,
                //存放所有大类，新增改制条目时用
                allOne:[],
                //存放所有的改制大类，新增改制条目时用
                allDivision:[],
                //存放所有链群，新增改制条目时用
                allLianqun:[],
                createSpecificData : {
                    oneLId:'', //大类编码
                    oneLName:'',//大类名称
                    lianqunCode:'', //链群编码
                    lianqunName:'',//链群名称
                    specificDivision: '',//改制大类
                    specificReform: '',//改制描述
                    reformPrice:'',//单台加价
                    remark:'', //备注
                    specificType:'2',//改制类型 1-内销，2-外销，3-通用
                },
                specificReformList:[],
            }
        },
        created() {
            this.saveData.isOther = "";
            this.saveData.isScheduling = "";
            this.saveData.isStandard = '';
            this.saveData.receivingAddress = '';
            this.isShowDia();
        },
        watch: {
            'saveData.specificList': {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    // this.f.reformPrice = _.reduce(_.map(newValue, "reformPrice"), function (sum, v) {
                    //     return new big(sum).plus(v||0).toString();
                    // }, 0)
                    var reformPrice = 0;
                    for(var i = 0;i<newValue.length;i++){
                        reformPrice += newValue[i].reformPrice?newValue[i].reformPrice* newValue[i].reformNum:0;
                    }
                    this.saveData.reformPriceRmb = reformPrice + this.saveData.otherYcReformPrice; //定制加价 + 占用其他预测加价
                },
            },

            'saveData.otherYcReformPrice' :{
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {

                    var reformPrice = 0;
                    for(var i = 0;i<this.saveData.specificList.length;i++){
                        reformPrice += this.saveData.specificList[i].reformPrice?this.saveData.specificList[i].reformPrice* this.saveData.specificList[i].reformNum:0;
                    }
                    this.saveData.reformPriceRmb = reformPrice + this.saveData.otherYcReformPrice; //定制加价 + 占用其他预测加价
                },
            },


        },
        methods:{
            isNotPre(){
                ss.waixiao.isNotPreCount().then(rd => {
                    this.isNotDisplay = rd;
                })
            },
            addNumber(){
                this.saveData.proNumber = 0;
                var num = 0;
                if(this.ycTable.length>0){
                    for(var i=0;i<this.ycTable.length;i++){
                        num += parseInt(this.ycTable[i].useNumber);
                    }
                }
                if(this.saveData.oneNumber == null || this.saveData.oneNumber == ''){
                    this.saveData.oneNumber = 0
                }
                if(this.saveData.otherNumber == null || this.saveData.otherNumber == ''){
                    this.saveData.otherNumber = 0
                }
                if(this.saveData.ypNumber == null || this.saveData.ypNumber == ''){
                    this.saveData.ypNumber = 0
                }
                this.saveData.proNumber = parseInt(this.saveData.oneNumber) + parseInt(this.saveData.otherNumber)+parseInt(this.saveData.ypNumber)+num;
            },
            ypRelease(){
                if(this.saveData.oneNumber > this.saveData.ypNumber){
                    this.ypDisabled = false
                }else {
                    this.ypDisabled = true
                }
                this.addNumber();
            },
            getYbTable(){
                this.ybTable = [];
                for(var i=0;i<this.saveData.ypIds.length;i++){
                    for(var t=0;t<this.getypData.length;t++){
                        if(this.saveData.ypIds[i]==this.getypData[t].id){
                            this.ybTable.push(this.getypData[t]);
                            // if(this.getypData[t].isSpecific==2){
                            //     this.saveData.isSpecific = this.getypData[t].isSpecific;
                            //     this.saveData.specific = this.getypData[t].specificReq.split(",");
                            //     this.saveData.specificReform = this.getypData[t].specificReform;
                            //     this.saveData.reformPriceRmb = this.getypData[t].reformPriceRmb;
                            // }else {
                            //     this.saveData.isSpecific = this.getypData[t].isSpecific;
                            // }

                        }
                    }
                }
            },
            submitFlage(data){
                this.tableData = [];
                console.log("savedata data ",this.saveData)
                this.tableData.push(this.saveData);
                console.log("tableData data ",this.tableData)

                if(this.saveData.factory == '' || this.saveData.factory == null){
                    this.$msg.msge("产地不能为空，请检查销售样表(外)！");
                    return;
                }

                var f = true;
                var lkid = this.lkYcid;
                var flag = true;
                b:
                    if (f) {
                        var cou = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < this.tableData.length; i++) {
                            for (var j = 0; j < cou.length; j++) {
                                if (cou[j].name == this.tableData[i].country) {
                                    this.tableData[i].country = cou[j].code
                                }
                            }
                            if (this.tableData[i].isSpecific == 2) {
                                //循环设置
                                this.tableData[i].specificReq = _.join(this.tableData[i].specific || [], ",");
                            } else {
                                this.tableData[i].specificId = '';
                                this.tableData[i].specificReq = '';
                            }

                            if (this.tableData[i].useData && this.tableData[i].useData != '') {
                                this.tableData[i].useMeg = _.join(this.tableData[i].useData || [], ",");
                                this.tableData[i].useId = _.join(this.tableData[i].useData || [], ",");
                            } else {
                                this.tableData[i].useId = '';
                                this.tableData[i].useMeg = '';
                            }

                            // this.tableData[i].prolist = [];
                            // this.tableData[i].modelOpt = [];
                            // this.tableData[i].codeOpt = [];
                            this.tableData[i].preId = '';
                            this.tableData[i].otherUseId = '';
                            if (this.tableData[i].ypIds) {
                                this.tableData[i].preId = _.join(this.tableData[i].ypIds || [], ",");
                            }
                            if (this.tableData[i].useOtherData) {
                                this.tableData[i].otherUseId = _.join(this.tableData[i].useOtherData || [], ",");
                            }
                            if (!this.tableData[i].specificType || this.tableData[i].specificType == '') {
                                if (this.tableData[i].isSpecific == 1) {
                                    this.tableData[i].specificType = '1';
                                } else {
                                    var index = this.tableData[i].specificId.indexOf("0");
                                    if (index == -1) {
                                        this.tableData[i].specificType = '1';
                                    } else {
                                        this.tableData[i].specificType = '2';
                                    }
                                }
                            }
                            // console.log(this.tableData[i].specificType,"????");
                        }
                    }
                //提交之前如果是冷库,先判断是否上传附件
                if(this.lkFlag){
                    this.subLkData.id = lkid;
                    this.subLkData.isStandard = this.saveData.isStandard;
                    ss.waixiao.checkLkfj(this.subLkData).then(rd => {
                        flag = rd.msg;
                        if(!flag){
                            this.$msg.msge("冷库产品必须上传附件才可提交!");
                        }else {
                            if(data == '提交'){
                                this.subTo();
                            }else {
                                this.saveTo();
                            }
                        }
                    })
                }else {
                    if(data == '提交'){
                        this.subTo();
                    }else {
                        this.saveTo();
                    }
                }
            },
            saveTo() {
                // console.log(this.tableData,"内容是什么");
                ss.waixiao.saveTo(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.lkFlag = false;
                    this.lkYcid = '';
                    this.$parent.query();
                })
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    this.submitData = this.tableData;
                    if (this.submitData.length == 0) {
                        this.$msg.msge("数据不能为空,请填写数据!");
                    } else {
                        var f = true;
                        b:
                            if (f) {
                                var cou = this.$store.getters.dictlist("YLCountry_agent");
                                for (var i = 0; i < this.submitData.length; i++) {
                                    for (var j = 0; j < cou.length; j++) {
                                        if (cou[j].name == this.submitData[i].country) {
                                            this.submitData[i].country = cou[j].code
                                        }
                                    }
                                    if (this.submitData[i].isSpecific == 2) {
                                        //循环设置
                                        this.submitData[i].specificReq = _.join(this.submitData[i].specific || [], ",");
                                    } else {
                                        this.submitData[i].specificId = '';
                                        this.submitData[i].specificReq = '';
                                    }
                                    // if(!this.submitData[i].useMeg || this.submitData[i].useMeg == '' || this.submitData[i].useMeg == null){
                                    //     this.$msg.msg("第"+(i+1)+"行，预测单未选择")
                                    //     return
                                    // }
                                    // this.submitData[i].prolist = [];
                                    // this.submitData[i].modelOpt = [];
                                    // this.submitData[i].codeOpt = [];

                                    if (!this.submitData[i].specificType || this.submitData[i].specificType == '') {
                                        if (this.submitData[i].isSpecific == 1) {
                                            this.submitData[i].specificType = '1';
                                        } else {
                                            var index = this.submitData[i].specificId.indexOf("0");
                                            if(index == -1){
                                                this.submitData[i].specificType = '1';
                                            }else{
                                                this.submitData[i].specificType = '2';
                                            }
                                        }
                                    }
                                    if(!this.submitData[i].country || this.submitData[i].country == '' || this.submitData[i].country == null){
                                        return this.$msg.msge("国家不能为空");
                                    }
                                    if(!this.submitData[i].area || this.submitData[i].area == '' || this.submitData[i].area == null){
                                        return this.$msg.msge("区域不能为空");
                                    }
                                    if(!this.submitData[i].proCode || this.submitData[i].proCode == '' || this.submitData[i].proCode == null){
                                        return this.$msg.msge("产品编码不能为空");
                                    }
                                    if(!this.submitData[i].proNumber || this.submitData[i].proNumber == '' || this.submitData[i].proNumber == null){
                                        return this.$msg.msge("数量不能为空");
                                    }
                                    if(!this.submitData[i].isSpecific || this.submitData[i].isSpecific == '' || this.submitData[i].isSpecific == null){
                                        return this.$msg.msge("常规或改制不能为空");
                                    }
                                    if(this.submitData[i].isSpecific == '2' || this.submitData[i].isSpecific == 2){
                                        if(!this.submitData[i].isReformStock || this.submitData[i].isReformStock == '' || this.submitData[i].isReformStock == null){
                                            return this.$msg.msge("改制类型不能为空");
                                        }
                                        if(this.submitData[i].protype == '自产' && this.saveData.proModelCode != 'ND1' && this.saveData.proModelCode != 'KS1' && this.saveData.proModelCode != 'HH1'  && this.saveData.proModelCode != 'YX1'){
                                            if(this.submitData[i].specificList.length < 1){
                                                return this.$msg.msge("改制目录不能为空！");
                                            }
                                            this.submitData[i].specificList.forEach((item, index) => {
                                                if (item.specificType == ''|| item.specificDivision== '' || item.specificReform== '') {
                                                    this.$msg.msge("请完善改制信息！");
                                                    subflag0 = false;
                                                    return false;
                                                }
                                            })
                                        }
                                    }
                                    if(!this.submitData[i].isReal || this.submitData[i].isReal == '' || this.submitData[i].isReal == null){
                                        return this.$msg.msge("是否实单不能为空");
                                    }
                                    if(this.submitData[i].isReal == '1'){
                                        if(!this.submitData[i].deliveryDate || this.submitData[i].deliveryDate == '' || this.submitData[i].deliveryDate == null){
                                            return this.$msg.msge("预计交货时间不能为空");
                                        }
                                    }
                                    if(this.submitData[i].isScheduling == '1' || this.submitData[i].isScheduling == '2'){
                                        if(!this.submitData[i].ypIds || this.submitData[i].ypIds == '' || this.submitData[i].ypIds == null){
                                            return this.$msg.msge("预排单号不能为空");
                                        }
                                    }
                                    if(this.isAddress) {
                                        if (!this.submitData[i].receivingAddress || this.submitData[i].receivingAddress == '' || this.submitData[i].receivingAddress == null) {
                                            return this.$msg.msge("收货地址不能为空");
                                        }
                                    }

                                    if(!this.submitData[i].factory || this.submitData[i].factory == '' || this.submitData[i].factory == null){
                                        return this.$msg.msge("产地不能为空");
                                    }

                                    if(this.submitData[i].isOther == '1'){
                                        if(!this.submitData[i].useData || this.submitData[i].useData == '' || this.submitData[i].useData == null){
                                            return this.$msg.msge("预测单号不能为空");
                                        }else {
                                            var nu = 0;
                                            for(var t=0;t<this.ycTable.length;t++){
                                                nu += this.ycTable[t].useNumber;
                                            }
                                            if(nu < this.submitData[i].proNumber){
                                                return this.$msg.msge("预测数量不能大于占用预测的可录单数量");
                                            }
                                        }
                                    }else if(this.submitData[i].isOther == '2'){
                                        if(!this.submitData[i].useOtherData || this.submitData[i].useOtherData == '' || this.submitData[i].useOtherData == null){
                                            return this.$msg.msge("他人预测单号不能为空");
                                        }else {
                                            var nu1 = 0;
                                            for(var q=0;q<this.OtherTable.length;q++){
                                                nu1 += this.OtherTable[q].useNumber;
                                            }
                                            if(nu1 < this.submitData[i].proNumber){
                                                return this.$msg.msge("预测数量不能大于占用预测的可录单数量");
                                            }
                                        }
                                    }
                                    if(this.submitData[i].protype == 'OEM') {
                                        if(!this.submitData[i].deliveryMethod || this.submitData[i].deliveryMethod == '' || this.submitData[i].deliveryMethod == null){
                                            return this.$msg.msge("发货方式不能为空");
                                        }
                                    }

                                }

                                ////ss.waixiao.subTo(this.submitData).then(rd => {
                                //// 新版提交
                                ss.waixiao.submitNewTo(this.submitData).then(rd => {
                                    console.log("報錯123")
                                    this.$msg.msgs(rd.msg);
                                    this.submitData = [];
                                    this.lkFlag = false;
                                    this.lkYcid = '';
                                    this.$router.push({path: "/yuce/wxxiangqing"});
                                }).catch(error => {
                                    this.items.prolist = this.saveData.prolist
                                    console.log("ff")
                                });
                            }
                    }
                })
            },

            changes(v) {
                if (this.saveData.isSpecific == 1) {
                    this.saveData.specific = '';
                    this.saveData.specificReq = '';
                    this.saveData.specificId = '';
                    this.saveData.specificType = '1';
                    this.saveData.specificReform = '';
                    this.saveData.reformPriceRmb = '';
                    this.saveData.otherYcReformPrice = 0;
                    this.disabledOther = false;
                    this.saveData.isOther = null;
                    this.saveData.otherNumber = 0;
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                    this.saveData.isReformStock=null;
                }else {
                    this.isYPdisabled = false;
                    this.saveData.isScheduling = null;
                    this.saveData.ypIds = [];
                    this.ybTable = [];
                    if(this.saveData.proModelCode != 'ND1' && this.saveData.proModelCode != 'KS1' && this.saveData.proModelCode != 'HH1' && this.saveData.proModelCode != 'YX1'){
                        this.specificSelectList(this.saveData.proModelCode);
                    }
                }
            },
            addUseId(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.useId='';
                this.ycTable = [];
                //设为0 再重新计算
                this.saveData.otherYcReformPrice =0;
                if (this.saveData.useData && this.saveData.useData.length != 0 && this.saveData.uids && this.saveData.uids.length != 0) {
                    for (var i = 0; i < this.saveData.useData.length; i++) {
                        for (var j = 0; j < this.saveData.uids.length; j++) {
                            if (this.saveData.useData[i] == this.saveData.uids[j].name) {
                                if (this.saveData.useId != null && this.saveData.useId != '') {
                                    this.saveData.useId = this.saveData.useId + this.saveData.uids[j].code + ","
                                } else {
                                    this.saveData.useId = this.saveData.uids[j].code + ","
                                }
                            }
                        }

                        for(var t=0;t<this.ycList.length;t++){
                            if(this.ycList[t].id == this.saveData.useData[i]){
                                //计算占用加价
                                this.saveData.otherYcReformPrice = this.saveData.otherYcReformPrice + this.ycList[t].reformPriceRmb ;

                                this.ycTable.push(this.ycList[t]);
                            }
                        }
                    }

                }
            },
            addUseIdOther(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.otherUseId='';
                this.OtherTable = [];
                //设为0 再重新计算
                this.saveData.otherYcReformPrice =0;
                if (this.saveData.useOtherData && this.saveData.useOtherData.length != 0 && this.saveData.otherUseIds && this.saveData.otherUseIds.length != 0) {
                    if(this.saveData.useOtherData.length > 1){
                        return this.$msg.msge("只能选择一个他人预测");
                    }
                    for (var i = 0; i < this.saveData.useOtherData.length; i++) {
                        for (var j = 0; j < this.saveData.otherUseIds.length; j++) {
                            if (this.saveData.useOtherData[i] == this.saveData.otherUseIds[j].name) {
                                if (this.saveData.otherUseId != null && this.saveData.otherUseId != '') {
                                    this.saveData.otherUseId = this.saveData.otherUseId + this.saveData.otherUseIds[j].code + ","
                                } else {
                                    this.saveData.otherUseId = this.saveData.otherUseIds[j].code + ","
                                }
                            }
                        }
                        for(var t=0;t<this.getOtherData.length;t++){
                            if(this.getOtherData[t].id == this.saveData.useOtherData[i]){
                                //计算占用加价
                                this.saveData.otherYcReformPrice = this.saveData.otherYcReformPrice + this.getOtherData[t].reformPriceRmb ;

                                this.OtherTable.push(this.getOtherData[t]);
                            }
                        }
                    }
                }
            },
            decide() {
                if (this.saveData.productModel != this.items.proModel && this.saveData.productCode != this.items.proCode) {
                    this.items.proModel = this.saveData.productModel;
                    this.items.proCode = this.saveData.productCode;
                    // this.items.describe = [];
                    this.items.specificReq = [];
                    this.items.uids = [];
                    this.items.useData = [];
                    this.items.specific = [];
                    this.items.specificReform = '';
                    this.items.reformPriceRmb = '';
                    this.items.otherYcReformPrice = 0;
                    this.saveData.specificList =  [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:1,//改制数量
                        specificRemark:'',//改制备注
                    }];
                }
                ss.waixiao.selectProType(this.items.proCode, 2).then(rd => {
                    this.saveData.protype = rd;
                    if(rd = 'OEM'){
                        this.saveData.deliveryMethod = '2';
                        var data = {};
                        data.materialCode = this.items.proCode;
                        //oem产品获取OEM产品描述
                        ss.chanpin.selectListByCode(data).then(rd => {
                            if (rd) {
                                this.saveData.oemDesc = rd.oemDesc;
                            }
                        })
                    }else {
                        this.saveData.deliveryMethod = '';
                    }
                })
                // this.selectDingzhi(this.items);
                this.selectStock(this.items);
                this.selectStockOther(this.items);
                this.checkLengku(this.items.proCode);
                this.checkOemAnd6200(this.items.proCode);
                //获取产地
                this.getMaterialFactory(this.items.proCode);
            },
            getYPlist(data){
                this.ybTable = [];
                this.saveData.ypIds = [];
                this.getypData=[];
                ss.waixiao.selectPreList(data).then(rd => {
                    this.getypData = rd;
                })
            },
            getOtherYPlist(data){
                this.ybTable = [];
                this.saveData.ypIds = [];
                this.getypData=[];
                ss.waixiao.selectOtherPreList(data).then(rd => {
                    this.getypData = rd;
                })
            },
            selectStock(v) {
                this.ycList = [];
                this.saveData.uids = [];
                this.ycTable = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectStock(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.ycList = rd;
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                })
            },
            selectStockOther(v) {
                this.OtherTable = [];
                this.saveData.ypIds = [];
                this.saveData.otherUseIds = [];
                this.getOtherData=[];
                this.saveData.useOtherData = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectStockOther(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.getOtherData = rd;
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.otherUseIds.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                })
            },
            isYp(){
                var form = {}
                form.country = this.saveData.country;
                form.proCode = this.saveData.productCode;
                form.proModel = this.saveData.productModel;

                if(this.saveData.isOther){
                    /*如果占用预测单改制方式锁死为库存改制*/
                    this.isKcgz=true;
                    this.saveData.isReformStock="1";
                }else{
                    /*如果不占用预测单改制方式自己选*/
                    this.isKcgz=false;
                    this.saveData.isReformStock = null;
                }

                if(this.saveData.isOther && this.saveData.isOther == '1'){

                    this.saveData.isScheduling = null;
                    this.ybTable = [];
                    this.saveData.ypIds = [];
                    this.getypData=[];
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                }else if(this.saveData.isOther && this.saveData.isOther == '2'){

                    this.saveData.isScheduling = null;
                    this.ybTable = [];
                    this.saveData.ypIds = [];
                    this.getypData=[];
                    this.saveData.useData = [];
                    this.ycTable = [];
                }else {

                    this.saveData.useData = [];
                    this.ycTable = [];
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                    this.getYPlist(form)
                }
            },
            dataFilter(val){
                console.log("val",val);
                val = val.replace(/\s*/g, "");
                this.productCode = val;
                if (val) { //val存在
                    this.pCode = this.pCodecopy.filter((item) => {
                        if (!!~item.indexOf(val) || !!~item.toUpperCase().indexOf(val.toUpperCase())) {
                            return true
                        }
                    })
                } else { //val为空时，还原数组
                    this.pCode = this.pCodecopy;
                }
            },
            selectCode(v) {
                console.log(123,this.saveData.productCode);
                console.log(456, this.items.prolist);
                for (var key in this.items.prolist) {
                    if (this.saveData.productCode == key) {
                        console.log(789,this.items.prolist[key]);
                        this.saveData.productModel = this.items.prolist[key];
                    }
                }
                this.decide();
            },
            clickmodel() {
                // this.saveData.deliveryMethod = '';
                this.saveData.isReformStock = null;
                // this.saveData.isShipDate = '';
                // this.saveData.shippingDate = '';
                this.saveData.proModel = '';
                this.saveData.proCode = '';
                this.saveData.productCode = '';
                this.saveData.productModel = '';
                this.saveData.protype = '';
                this.saveData.proNumber = 0;
                this.saveData.useId = '';
                this.saveData.useMeg = '';
                this.saveData.isSpecific = '';
                this.saveData.specificReform = '';
                this.saveData.specificReq = '';
                this.saveData.specific = '';
                this.saveData.reformPriceRmb = '';
                this.saveData.otherYcReformPrice = 0;
                this.saveData.specificType = '1';
                this.saveData.useData = [];
                this.saveData.uids = [];
                this.saveData.prolist = [];
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.remark = '';
                this.saveData.deliveryDate = '';
                this.saveData.proModelCode='';
                this.saveData.factory='';
                if (this.saveData.country && this.saveData.country != '') {
                    this.f.productModel = this.saveData.proModel;
                    this.f.productCode = this.saveData.proCode;
                    this.items = this.saveData;
                    if (this.saveData.codeOpt.length == 0 || this.saveData.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == this.saveData.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = this.saveData.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            this.saveData.prolist = rd;
                            for (var key in rd) {
                                this.saveData.modelOpt.push(rd[key]);
                                this.saveData.codeOpt.push(key);
                            }
                            this.pModel = this.saveData.modelOpt;
                            this.pCode = this.saveData.codeOpt;
                            this.pCodecopy = this.saveData.codeOpt;
                            this.disabled = false;
                        })
                    } else {
                        this.pModel = this.saveData.modelOpt;
                        this.pCode = this.saveData.codeOpt;
                        this.pCodecopy = this.saveData.codeOpt;
                        this.disabled = false;
                    }
                } else {
                    this.$msg.msge("请先选择国家！");
                }
            },
            showCountry() {
                var country = this.$store.getters.dictlist("YLCountry_agent");
                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                        }
                    }
                })
            },
            showArea() {
                ss.waixiao.getArea().then(rd => {
                    this.areaList = rd
                    this.areaList = this.areaList.filter(item => item.qyname !== 'UN');//排除UN
                    this.saveData.area = rd[0].qycode;
                })
            },
            isShowDia(){
                let self = this
                this.disabled=true;
                this.ybTable = [];
                this.OtherTable = [];
                this.ycTable = [];
                this.gjCo = [];
                // this.saveData.deliveryMethod = '';
                this.saveData.isReformStock = null;
                // this.saveData.isShipDate = '';
                // this.saveData.shippingDate = '';
                this.saveData.area = '';
                this.saveData.proModel = '';
                this.saveData.proCode = '';
                this.saveData.protype = '';
                this.saveData.country = '';
                this.saveData.productModel = '';
                this.saveData.productCode = '';
                this.saveData.proModel = '';
                this.saveData.proCode = '';
                this.saveData.protype = '';
                this.saveData.proNumber = 0;
                this.saveData.useId = '';
                this.saveData.useMeg = '';
                this.saveData.isSpecific = '';
                this.saveData.specificReform = '';
                this.saveData.specificReq = '';
                this.saveData.specific = '';
                this.saveData.reformPriceRmb = '';
                this.saveData.otherYcReformPrice = 0;
                this.saveData.specificType = '1';
                this.saveData.useData = [];
                this.saveData.uids = [];
                this.saveData.prolist = [];
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.oneNumber=0;
                this.saveData.otherNumber=0;
                this.saveData.ypNumber=0;
                this.saveData.otherUseIds=[];
                this.saveData.useOtherData=[];
                this.saveData.isReal = '';
                this.saveData.remark = '';
                this.saveData.deliveryDate = '';
                this.saveData.ypIds=[];
                this.saveData.isOther='';
                this.saveData.proModelCode='';
                this.saveData.factory='';
                this.showCountry();
                this.showArea();
                this.isNotPre();
            },
            //判断是否是冷库产品
            checkLengku(val){
                ss.waixiao.isLk(val).then(rd => {
                    this.lkFlag = rd.msg;
                    //如果是冷库产品,则在新增时需先生成一个虚拟的预测单号用于绑定附件,点击预测单提交时更新绑定真实的预测单编号
                    if(this.lkFlag){
                        this.saveData.isLk = 1;
                        ss.waixiao.createLkYcid().then(rd => {
                            this.lkYcid = rd.msg;
                            this.saveData.lkYcId = rd.msg;
                            console.log("lkycid",this.lkYcid )
                        })
                    }
                })
            },
            //判断是不是ome6200产品
            checkOemAnd6200(val){
                ss.waixiao.isOemAnd6200(val).then(rd => {
                    this.isOemAnd6200 = rd;
                    //如果是ome产品并且产地是6200,校验是不是直发,如果是直发则收货单位必填
                    if(this.isOemAnd6200 && this.saveData.deliveryMethod == 1){
                        this.isAddress = true;
                    }else {
                        this.isAddress = false;
                    }
                })
            },
            //获取外销销售样表产地
            getMaterialFactory(val){
                ss.salesListF.selectModel(val).then(rd => {
                    if(rd){
                        this.saveData.factory = rd.factory;
                        this.saveData.proModelCode = rd.oneLid;
                        if(this.saveData.isSpecific == '2' && rd.oneLid != 'ND1' && rd.oneLid != 'KS1' && rd.oneLid != 'HH1' && rd.oneLid != 'YX1'){
                            this.specificSelectList(rd.oneLid);
                        }
                    }
                })
            },
            isUpload(v) {
                console.log(v)
                if (v.length > 0) {
                    //this.order.fileUrl = v[0].saveurl;
                    let arrnew = []
                    v.forEach(e => {
                        arrnew.push(e.saveurl)
                    })
                    console.log(arrnew)
                    this.saveData.fileUrl = arrnew
                    console.log(this.saveData.fileUrl)
                }else{
                    this.order.fileUrl =[]
                }
            },
            handleDialogClose() {
                this.lkFlag = false
                this.csFlag = false
                this.saveData.isStandard = '',
                    this.dialogFormVisible = false
            },
            isStandardChange() {
                if(this.saveData.isStandard == 2){
                    this.$message('请上传投标参数及海尔配置清单');
                }else if(this.saveData.isStandard == 1){
                    this.$message('请上传海尔配置清单');
                }
            },
            //收货单地址
            handleIconClick() {
                this.showflag = true;
            },
            choseAddress(obj) {
                console.log(obj)
                this.showflag = false;
                if (obj.zhenobj && obj.zhenobj.name) {
                    this.saveData.receivingAddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
                } else {
                    this.saveData.receivingAddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
                }
            },
            //根据大类编码查询改制条目
            specificSelectList(oneLId) {
                specificCatalogue.selectByOneLId({oneLId: oneLId,specificType:2}).then(rd => {
                    this.specificCatalogueList = rd;
                    console.log(this.specificCatalogueList)
                    //过滤出所有改制目录
                    this.specificDivisionList = [];
                    for (let item of rd) {
                        if (this.specificDivisionList.indexOf(item.specificDivision) == -1) {
                            this.specificDivisionList.push(item.specificDivision);
                        }
                    }
                    //过滤出所有可选链群
                    this.lianqunList = [];
                    // this.f.lianqun='';
                    // this.f.lianqunName='';
                    for (let item of rd) {
                        if (this.lianqunList.findIndex(item => item.lianqunCode=== item.lianqunCode) == -1) {
                            this.lianqunList.push(item);
                        }
                    }
                    console.log("lianqunList",this.lianqunList);


                })
            },
            //新增改制条目
            createSpecific() {
                this.createSpecificFlag = true;
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            },
            getOneLName(q){
                //获取name
                const one = _.find(this.allOne,{oneLId:q})

                this.createSpecificData.oneLName = one.oneLName;
                console.log("this.createSpecificData.oneLName",this.createSpecificData.oneLName)
                this.selectAllDivision(q);
            },
            selectAllDivision(oneLId){
                //查询所有改制目录
                specificCatalogue.selectAllDivision({oneLId: oneLId}).then(rd => {
                    this.allDivision = [];
                    for (let item of rd) {
                        if (this.allDivision.indexOf(item.specificDivision) == -1) {
                            this.allDivision.push(item.specificDivision);
                        }
                    }
                    //过滤出所有可选链群
                    this.allLianqun = [];
                    this.createSpecificData.lianqunCode='';
                    this.createSpecificData.lianqunName='';
                    for (let item of rd) {
                        if (this.allLianqun.findIndex(item => item.lianqunCode=== item.lianqunCode) == -1) {
                            this.allLianqun.push(item);
                        }
                    }

                })
            },
            getLianqunName(q){
                //获取name
                const lianqun = _.find(this.allLianqun,{lianqunCode:q})

                this.createSpecificData.lianqunName = lianqun.lianqunName;
                console.log("this.createSpecificData.oneLName",this.createSpecificData.lianqunName)
            },
            //关闭改制条目
            closeSpecific(){
                this.createSpecificData.oneLId = null;
                this.createSpecificData.oneLName = null;
                this.createSpecificData.lianqunCode = null;
                this.createSpecificData.lianqunName = null;
                this.createSpecificData.specificDivision = null;
                this.createSpecificData.specificReform = null;
                this.createSpecificData.reformPrice = null;
                this.createSpecificData.remark = null;
                this.createSpecificData.specificType='2',
                this.createSpecificFlag = false;

            },
            //提交改制条目
            commitSpecific(){
                this.$refs['specificForm'].validate((valid0) => {
                    if (valid0) {
                        this.$msg.confirm("确认提交？",()=>{
                            specificCatalogue.insert(this.createSpecificData).then(rd => {
                                this.closeSpecific();
                            })
                        })
                    }else{
                        this.$msg.msge("请完善基本信息后提交");
                        return;
                    }
                });

            },
            //增加一行改制信息
            addSpecific() {
                this.saveData.specificList.push({
                    specificId: '',//改制id
                    specificDivision: '',//改制目录
                    specificReform: '',//改制要求
                    reformPrice: '',//单台加价
                    specificType:'',//1目录内改制 2目录外改制
                    reformNum: 1,//改制数量
                    specificRemark:'',
                })
            },
            //选择改制目录
            chooseDivision(specificDivision,index){

                this.specificReformList[index] = _.filter(this.specificCatalogueList, {specificDivision: specificDivision})

                this.saveData.specificList[index].specificId = null;
                this.saveData.specificList[index].specificReform = null;
                this.saveData.specificList[index].reformPrice = null;
                this.saveData.specificList[index].reformNum = 1;
                this.saveData.specificList[index].specificRemark = null;
                if(specificDivision=='改制目录外'){
                    this.saveData.specificList[index].specificType = 2;
                }else{
                    this.saveData.specificList[index].specificType = 1;
                }
            },

            //选择改制要求
            chooseReform(specific,index){
                this.saveData.specificList[index].specificId = specific.id;
                this.saveData.specificList[index].specificReform = specific.specificReform;
                if(this.saveData.protype == 'OEM'){
                    this.saveData.specificList[index].reformPrice = 0;
                }else {
                    this.saveData.specificList[index].reformPrice = specific.reformPrice;
                }

            },

            calReformPrice(){

            },
            //减少一行改制信息
            deleteSpecific(index) {
                this.saveData.specificList.splice(index, 1)

            },
            //返回
            backS() {
                this.$router.push({path: "/yuce/wxxiangqing"});
            },
        },
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
